import { connect } from 'react-redux'
import Article from 'pages/currentawarenessarticle/Article'

const mapStateToProps = state => ({
  isLogged: state.user.isLogged
})

export default connect(mapStateToProps, null)(Article)
